module.exports = __webpack_public_path__ + "media/icons/offer-details-budowlane-de511dbc.png";